import './assets/css/app.css';
import './assets/css/font-awesome.min.css';
import { LoadTitlePage } from './Components/Public/Functions/LoadTitlePage.js';
import { RouterPublic } from './Routes/RouterPublic.js';
import { RouterAdmin } from './Routes/RouterAdmin.js';

function App() {
    const uri = window.location.pathname;
    const main = uri.includes('admin') ? 'admin' : 'public';
    LoadTitlePage();
    return (
        <main id="main" className={`main ${main}`}>
            <div className="block-push" id="blocktop"></div>
            <RouterPublic />
            <RouterAdmin />
        </main>
    );
}
export default App;
